import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Document, Organization } from '../../../shared/sdk';
import { DocumentService } from '../../document.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-active-document-card',
  templateUrl: './active-document-card.component.html',
  styleUrls: ['./active-document-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveDocumentCardComponent implements OnInit {
  @Input() activeOrg: Organization;
  @Input() currentLang: string;
  @Input() document: Document;
  @Input() incoming: boolean;
  @Input() isChecked: boolean;
  @Input() last = false;
  @Output() addPayment = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() check = new EventEmitter();
  @Output() delete = new EventEmitter();

  constructor(
    private documentService: DocumentService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  get isPast(): boolean {
    return this.documentService.isPast(this.document);
  }

  ngOnInit(): void {}

  onAddPayment(document: Document): void {
    this.addPayment.emit(document);
  }

  onCancel(document: Document): void {
    this.cancel.emit(document);
  }

  onDelete(document: Document): void {
    this.delete.emit(document);
  }

  onOpen(): void {
    this.router.navigate(
      [
        '../../documents',
        !this.document.incoming ? 'o' : 'i',
        'view',
        this.document.id,
      ],
      { relativeTo: this.route },
    );
  }

  onToggleSelected(): void {
    this.check.emit(this.document);
  }

  get remainingDue(): number {
    return this.documentService.getRemainingDue(this.document);
  }
}
